<template>
  <div class="order">
    <div class="filter-container">
      <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="125px">
        <el-form-item label="活动名称">
          <el-input v-model="searchForm.activityName" placeholder="请输入活动名称"></el-input>
        </el-form-item>
        <el-form-item label="适用国家">
          <el-select filterable clearable v-model="searchForm.activityCountry" placeholder="请选择国家">
            <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select filterable v-model="searchForm.status" clearable placeholder="请选择状态">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="币种">
          <el-select v-model="searchForm.currency" filterable clearable placeholder="请选择币种">
            <el-option label="CNY" value="0"></el-option>
            <el-option label="USD" value="1"></el-option>
            <el-option label="EUR" value="2"></el-option>
            <el-option label="GBP" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期">
          <el-date-picker
            v-model="searchForm.validDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="searchForm.createDateRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="primary" plain @click="handleResetQuery">重置</el-button>
      </el-form>
    </div>
    <div class="table-container">
      <div class="table-btn">
        <el-button
          type="text"
          icon="el-icon-plus"
          @click="handleAddOrEdit('新增')"
        >新增</el-button
        >
      </div>
      <el-table
        :data="tableData"
        highlight-current-row
        border
        stripe
      >
        <el-table-column
          type="selection"
          width="40"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="50"
          show-overflow-tooltip
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="activityName"
          label="活动名称"
        >
        </el-table-column>
        <el-table-column
          prop="activityDescription"
          label="活动描述"
        >
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="currency"
          label="币种"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.currency == 0 ? "CNY" : scope.row.currency == 1 ? "USD" : scope.row.currency == 2 ? "EUR" : "GBP" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
        >
          <template slot-scope="scope">
             <span :class="'status' + scope.row.status">
               {{ scope.row.status === 0 ? "未开始" : scope.row.status === 1 ? "进行中" :"已结束" }}
             </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="country"
          label="适用国家"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleViewCountry(scope.row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          align="center"
          width="280"
        >
          <template slot-scope="scope">
            {{ scope.row.validFrom ? scope.row.validFrom.replace('T', ' ') : '' }} ~ {{ scope.row.validTo ? scope.row.validTo.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="creator"
          label="创建人"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
          show-overflow-tooltip
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleAddOrEdit('编辑', scope.row)"
            >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleAssignCountry(scope.row)"
            >分配国家</el-button
            >
            <el-button
              size="mini"
              type="text"
              style="color: #f56c6c;"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
    <pre-set-dialog ref="preSetDialog" @success="getList" />
    <assign-country-dialog ref="assignCountryDialog" @success="getList" />
    <view-country-dialog ref="viewCountryDialog" />
  </div>
</template>
<script>
import {kdactivitySupportList, kdactivitySupportChangeStatus, kdactivitySupportExport, kdactivitySupportDelete} from "@/api/seek";
import { getSession } from "@/util/localStor";
import { getNations } from "@/util/getNation";
import { getDownloadFiles } from "@/util/downFile";
import PreSetDialog from "./activitySupportDialog.vue";
import AssignCountryDialog from "./assignCountryDialog.vue";
import ViewCountryDialog from "./viewCountryDialog.vue";
import {feedbackFormDelete} from "@/api/feedbackKD";

export default {
  components: {
    PreSetDialog,
    AssignCountryDialog,
    ViewCountryDialog
  },
  data() {
    return {
      tableData: [],
      status: "",
      page: 1,
      pageSize: 10,
      total: 0,
      nationList: [],
      statusList: [
        { id: 0, name: "未开始" },
        { id: 1, name: "进行中" },
        { id: 2, name: "已结束" }
      ],
      searchForm: {
        activityName: '',
        activityCountry: '',
        status: '',
        activityCurrency: '',
        validDateRange: [],
        createDateRange: []
      },
      searchInfo: {},
      deleteDialogVisible: false,
      deleteLoading: false,
      currentDeleteRow: null,
      // loading: false,
      // exportLoading: false
    };
  },
  mounted() {
    this.nationList = Object.values(getSession("nationList"));
    this.getList();
  },
  methods: {
    // 获取状态
    getStatus(data) {
      let status;
      if (data == 0) status = "未开始";
      if (data == 1) status = "进行中";
      if (data == 2) status = "已结束";
      return status;
    },
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch() {
      let params = { ...this.searchForm };
      if (params.validDateRange && params.validDateRange.length === 2) {
        params.validFrom = params.validDateRange[0];
        params.validTo = params.validDateRange[1];
      }
      delete params.validDateRange;
      if (params.createDateRange && params.createDateRange.length === 2) {
        params.createTimeStart = params.createDateRange[0];
        params.createTimeEnd = params.createDateRange[1];
      }
      delete params.createDateRange;
      this.searchInfo = params;
      this.page = 1;
      this.pageSize = 10;
      this.getList();
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = {
        activityName: '',
        activityCountry: '',
        activityStatus: '',
        activityCurrency: '',
        validDateRange: [],
        createDateRange: []
      };
      this.handleSearch();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await kdactivitySupportList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
      }
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 新增
    handleAddOrEdit(title, row = {}) {
      this.$refs.preSetDialog.init(title, row);
    },
    // 导出
    // async handleExport() {
    //   // this.exportLoading = true;
    //   let query = {
    //     data: {
    //       ...this.searchInfo
    //     }
    //   };
    //   const res = await kdactivitySupportExport(query);
    //   getDownloadFiles(res);
    //   if (res.fileName) {
    //     this.$DonMessage.success("导出成功！")
    //   }
    //   // this.exportLoading = false;
    // },
    // 查看适用国家
    handleViewCountry(row) {
      this.$refs.viewCountryDialog.init(row);
    },
    // 分配国家
    handleAssignCountry(row) {
      this.$refs.assignCountryDialog.init(row);
    },
    // 删除
    handleDelete(row) {
      this.currentDeleteRow = row;
      this.$confirm("确认删除当前活动支持吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        kdactivitySupportDelete({data: {activityId: row.activityId}}).then((res) => {
          if (res.status == 0) {
            this.$DonMessage.success("删除成功!");
            this.getList();
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.status0 {
  color: #e6a23c ;
}
.status1 {
  color: #08b849;
}
.status2 {
  color: #5f6f7f;
}

</style>
